<template>
    <div class="report-offline">
        <div class="totle-content">
            <div class="select-search">
                <div class="select-group">

                </div>
                <div class="button-group">
                    <!--<el-button type="primary" icon="el-icon-search" @click="occupancyrate">搜索</el-button>-->
                    <!--<el-button type="success" icon="el-icon-tickets" @click="downloadMater">导出</el-button>-->
                </div>

            </div>

            <div class="table-content">
                <el-table class="table-head" :data="offlineData" border>
                    <el-table-column align="center" type="index" width="50"></el-table-column>
                    <el-table-column align="center" prop="title" label="名称" min-width="80"></el-table-column>
                    <el-table-column align="center" prop="ccode" label="集中器编码" min-width="80"></el-table-column>
                    <el-table-column align="center" prop="pcode" label="设备编码" min-width="70"></el-table-column>
                    <el-table-column align="center" prop="mode" label="模式" min-width="50"></el-table-column>
                    <el-table-column align="center" prop="devno" label="设备属性" min-width="70"></el-table-column>
                    <el-table-column align="center" prop="stay" label="房源状态" min-width="70"></el-table-column>
                    <el-table-column align="center" prop="status" label="设备状态" min-width="70"></el-table-column>
                    <el-table-column align="center" prop="addr" label="地址" min-width="120" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" prop="time" label="时间" min-width="80" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" prop="staydate" label="操作" min-width="50">
                        <template slot-scope="scope">
                            <el-button @click="toHouse(scope.$index, offlineData)" type="text" size="small">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

        </div>
    </div>
</template>

<script>
    import store from "../store";
    var FileSaver = require('file-saver');

    export default {
        name: "ReportOffline",
        data() {
            return{
                offlineData:[],

            }
        },
        mounted(){
            this.$http.get(`${store.state.url}report/offlinehour/12/0/5000?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                .then((res) => {
                    if (res.Code == 0) {
                        let offlineData=[];
                        if(res.Data!=null) {
                            for (let i in res.Data) {
                                let mode, devno, stay, status, time;
                                if (res.Data[i].Param.mode == 0) {
                                    mode = '后付'
                                } else if (res.Data[i].Param.mode == 1) {
                                    mode = '预付'
                                } else {
                                    mode = '未知'
                                }

                                if (res.Data[i].Devno == 9) {
                                    if (res.Data[i].Virtual == 1) {
                                        devno = '虚拟电表';
                                    } else if (res.Data[i].Virtual == 2) {
                                        devno = '被虚拟节点';
                                    } else {
                                        devno = '个人房间';
                                    }
                                } else if (res.Data[i].Devno == 11) {
                                    devno = "独立";
                                } else if (res.Data[i].Devno == 13) {
                                    devno = "总公";
                                } else {
                                    devno = "-";
                                }

                                if (res.Data[i].Devno == 9 && res.Data[i].Virtual != 2 && res.Data[i].External != undefined) {
                                    if (res.Data[i].External.stay != undefined) {
                                        if (res.Data[i].External.stay) {
                                            stay = '入住';
                                        } else {
                                            stay = '空置';
                                        }
                                    } else {
                                        stay = "-";
                                    }
                                } else {
                                    stay = "-";
                                }

                                if (res.Data[i].Status == 0) {
                                    status = "在线";
                                }
                                else if (res.Data[i].Status == 1) {
                                    status = "离线";
                                }

                                if (res.Data[i].Expand != undefined && res.Data[i].Expand != null) {
                                    if (res.Data[i].Expand.lasttime != undefined && res.Data[i].Expand.lasttime != null) {
                                        time = res.Data[i].Expand.lasttime.time.replace("T", " ").replace("+08:00", " ").replace(/\.[0-9]{1,4}/, "")
                                    } else {
                                        time = '-'
                                    }
                                } else {
                                    time = '-'
                                }

                                offlineData[i] = {
                                    title: res.Data[i].Title,
                                    ccode: res.Data[i].Ccode,
                                    pcode: res.Data[i].Pcode,
                                    mode: mode,
                                    devno: devno,
                                    stay: stay,
                                    status: status,
                                    addr: res.Data[i].Addr,
                                    time: time,
                                    devid: res.Data[i].Uuid,
                                }
                            }
                        }
                        this.offlineData=offlineData;
                    } else {
                        this.offlineData=[];
                        this.$message(res.Message);
                    }
                })
        },

        methods:{
            toHouse(index, row) {
                let devid = row[index].devid;
                window.localStorage.devid = devid;
                this.$router.push('./house');
            }
        }

    }
</script>

<style scoped>

</style>